import axios from "axios";
import Cookies from "js-cookie";

const apiRb = axios.create({ baseURL: process.env.REACT_APP_API_RB });

apiRb.interceptors.request.use((config) => {
  const token = Cookies.get("x-access-token");
  if (token) {
    config.headers["x-access-token"] = token;
  }
  return config;
});

export default apiRb;
